import { ModelAttributes } from '../types';

const jobPostTypes: ModelAttributes.JobType[] = ['Full-time', 'Part-time', 'Internship'];

export default jobPostTypes;
